import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import CountryOfBirth from './country-of-birth';
import CountryOfBirthDetail from './country-of-birth-detail';
import CountryOfBirthUpdate from './country-of-birth-update';
import CountryOfBirthDeleteDialog from './country-of-birth-delete-dialog';

const CountryOfBirthRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<CountryOfBirth />} />
    <Route path="new" element={<CountryOfBirthUpdate />} />
    <Route path=":id">
      <Route index element={<CountryOfBirthDetail />} />
      <Route path="edit" element={<CountryOfBirthUpdate />} />
      <Route path="delete" element={<CountryOfBirthDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default CountryOfBirthRoutes;
